import { logOnlyOnce } from '../utils/logOnlyOnce';

export enum EnvironmentType {
  Local = 'dev-local',
  Dev = 'dev',
  PRSlot = 'dev-pr-slot',
  Test = 'test',
  Prod = 'prod',
}

const getEnvironmentFromUrl = (): EnvironmentType => {
  const hostname = window.location.hostname;

  // Pattern 1: digibank-mypage
  const match = hostname.match(/.*digibank-mypage(.*?)\..*?(\.local|\.no).*/);
  if (match?.[2]) {
    if (match[2] === '.no') {
      if (match[1] === '-dev') return EnvironmentType.Dev;
      if (match[1] === '-test') return EnvironmentType.Test;
      if (!match[1]) return EnvironmentType.Prod;
    } else if (match[2] === '.local') {
      return EnvironmentType.Local;
    }
    return EnvironmentType.Dev;
  }

  // Pattern 2: kunde-digibank-mypage Azure slots
  const azureMatch = hostname.match(/.*?kunde-digibank-mypage-(dev|test|prod)-web-internal-ad-slot.*?\.net.*/);
  if (azureMatch?.[1]) {
    return azureMatch[1] as EnvironmentType;
  }

  // Pattern 3: nettbank domain
  const nettbankMatch = hostname.match(/.*?nettbank[-]*(.*?)\.innovasjonnorge\.no.*/);
  if (nettbankMatch?.[1] !== undefined) {
    return nettbankMatch[1] === '' ? EnvironmentType.Prod : (nettbankMatch[1] as EnvironmentType);
  }

  // Pattern 4: PR slot
  const prSlotMatch = hostname.match(/.*kunde-digibank-mypage-dev-web-pr-\d+-slot\.azurewebsites\.net.*/);
  if (prSlotMatch) {
    return EnvironmentType.PRSlot;
  }

  throw new Error(`Unknown environment based on hostname: ${hostname}`);
};

export const isProdEnvironment = (): boolean => getEnvironmentFromUrl() === EnvironmentType.Prod;

export const useEnvironment = () => {
  const environment = getEnvironmentFromUrl();
  const isProd = environment === EnvironmentType.Prod;

  logOnlyOnce(`Environment: ${environment}, isProd: ${isProd}`);

  const caseHelpUrlContainer: Record<EnvironmentType, string> = {
    [EnvironmentType.Local]: 'https://prosjekt-dev.innovasjonnorge.no/',
    [EnvironmentType.Dev]: 'https://prosjekt-dev.innovasjonnorge.no/',
    [EnvironmentType.PRSlot]: 'https://prosjekt-dev.innovasjonnorge.no/',
    [EnvironmentType.Test]: 'https://prosjekt-test.innovasjonnorge.no/',
    [EnvironmentType.Prod]: 'https://prosjekt.innovasjonnorge.no/',
  };

  const caseHelpUrl = caseHelpUrlContainer[environment];

  return {
    isProd,
    environment,
    caseHelpUrl,
  };
};
